<!-- Modal Header -->
<div class="modal-header">
  <h4 class="modal-title h5" translate>Configure Iba Upload Tables</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  @if (ibaConfigIsLoading) {
    <div class="text-center p-3 h3">
      <em class="fa-solid fa-spinner fa-spin"></em>
    </div>
  }

  <ul class="list-group">
    @for (key of keys; track key) {
      <li class="list-group-item" [ngClass]="{'highlight': ibaConfig[key]}">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" (change)="setValue(key,ibaConfig[key])" [(ngModel)]="ibaConfig[key]" [disabled]="(!isAdminRole && !isTechAdminRole &&!isSuperAdminRole)" id="ipaCheck{{key}}">
          <label class="form-check-label" for="ipaCheck{{key}}" translate>{{key}}</label>
        </div>
      </li>
    }
  </ul>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col"></div>
      <div class="col-auto">
        <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
          <span translate>Cancel</span>
        </button>
        <button (click)="onSubmit()" class="btn btn-primary" type="button">
          <span translate>Send</span>
        </button>
      </div>
    </div>
  </div>
</div>
